module.exports = __webpack_public_path__ + "img/product_0_1.46497666.jpg";